/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';

import {
  StaticContentPlugin,
  IStaticContentPluginMethods,
  LoadingContentPlugin,
  ILoadingContentPluginMethods,
  ErrorContentPlugin,
  IErrorContentPluginMethods,
  IBlockchainProofMethods,
  BlockchainProofPlugin,
  ICancelPolicyMethods,
  CancelPolicyPlugin,
  IFormatPolicyDetailMethods,
  FormatPolicyDetailPlugin,
  IFormatTimelineDetailMethods,
  FormatTimelineDetailPlugin,
  IGetTransactionListMethods,
  GetTransactionListPlugin,
  IHeaderMethods,
  HeaderPlugin,
  IPolicyDetailMethods,
  PolicyDetailPlugin,
  IUpdateAckMethods,
  UpdateAckPlugin,
} from './plugins';

export type TAgent = IStaticContentPluginMethods &
  ILoadingContentPluginMethods &
  IErrorContentPluginMethods &
  IBlockchainProofMethods &
  ICancelPolicyMethods &
  IFormatPolicyDetailMethods &
  IFormatTimelineDetailMethods &
  IGetTransactionListMethods &
  IHeaderMethods &
  ILoadingContentPluginMethods &
  IPolicyDetailMethods &
  IUpdateAckMethods;

const getPlugins = () => {
  return [
    new StaticContentPlugin(),
    new ErrorContentPlugin(),
    new LoadingContentPlugin(),
    new BlockchainProofPlugin(),
    new CancelPolicyPlugin(),
    new FormatPolicyDetailPlugin(),
    new FormatTimelineDetailPlugin(),
    new GetTransactionListPlugin(),
    new HeaderPlugin(),
    new PolicyDetailPlugin(),
    new UpdateAckPlugin(),
  ];
};

export const getAgent = () => {
  return createAgent<TAgent>({
    plugins: getPlugins(),
  });
};
